import { render, staticRenderFns } from "./NotificationTemplateSetup.vue?vue&type=template&id=6f06168b&scoped=true"
import script from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplateSetup.vue?vue&type=style&index=0&id=6f06168b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06168b",
  null
  
)

export default component.exports